






















































































































































































































































































































































































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import booths from '@assets/booth_types.json'

settings =
  name: 'ActivationForm'

  vue:
    props: ['item', 'context', 'options']

    data: ->
      openPanel: null
      history: ''
      booth_options: booths
      promotion: ''

    computed:
      activationSponsor: ->
        sponsor_id = @item.sponsor_id.$oid
        sponsor = @options.sponsors.find((sponsor) -> sponsor.id == sponsor_id)
        return sponsor.name

    methods:
      hiAddHistory: ->
        return if !@history.length
        @item.history.push(@history)
        @history = ''

      hiAddPromotion: ->
        return unless @promotion.length
        @item.promotions.push(@promotion)
        @promotion = ''
      hiRemovePromotion: (promoIndex) ->
        @item.promotions = @item.promotions.filter((item, index) -> index != promoIndex)

export default VueOptions.vue settings
